import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../../lib/api";
import { AdminHeader, Modal, ConfirmDelete, EditBtn, AddBtn, Field } from "../../components/admin/AdminUI";

const empty = { title: "", venue: "", event_date: new Date().toISOString().slice(0, 10), event_time: "10:00", description: "", banner: "", registration_link: "", category: "Event", status: "upcoming" };

export default function EventsAdmin() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/admin/events").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    try {
      if (editing) await api.put(`/admin/events/${editing}`, form);
      else await api.post("/admin/events", form);
      toast.success(editing ? "Updated" : "Created");
      setOpen(false); setForm(empty); setEditing(null); load();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message); }
  };

  const edit = (e) => { setEditing(e.id); setForm({ ...empty, ...e, event_date: (e.event_date || "").slice(0, 10) }); setOpen(true); };
  const del = async (id) => { await api.delete(`/admin/events/${id}`); load(); toast.success("Deleted"); };

  return (
    <div>
      <AdminHeader title="Events & CME Programs" subtitle="Manage upcoming and past events" actions={<AddBtn onClick={() => { setEditing(null); setForm(empty); setOpen(true); }} />} />
      <div className="card-elev overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-brand-bg text-brand-muted text-xs uppercase tracking-wider">
            <tr><th className="px-4 py-3 text-left">Title</th><th className="px-4 py-3 text-left">Category</th><th className="px-4 py-3 text-left">Date</th><th className="px-4 py-3 text-left">Venue</th><th className="px-4 py-3 text-left">Status</th><th className="px-4 py-3 text-right">Actions</th></tr>
          </thead>
          <tbody className="divide-y divide-brand-border">
            {items.map((e) => (
              <tr key={e.id} className="hover:bg-brand-bg/50">
                <td className="px-4 py-3 font-semibold text-brand-text">{e.title}</td>
                <td className="px-4 py-3"><span className="text-xs px-2 py-0.5 rounded-full bg-brand-primary-light text-brand-primary font-semibold">{e.category}</span></td>
                <td className="px-4 py-3">{new Date(e.event_date).toLocaleDateString()} • {e.event_time}</td>
                <td className="px-4 py-3 text-brand-muted">{e.venue}</td>
                <td className="px-4 py-3"><span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${e.status === "upcoming" ? "bg-brand-accent/10 text-brand-accent" : "bg-slate-100 text-slate-600"}`}>{e.status}</span></td>
                <td className="px-4 py-3 text-right"><div className="inline-flex items-center gap-1"><EditBtn onClick={() => edit(e)} /><ConfirmDelete onConfirm={() => del(e.id)} /></div></td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={6} className="px-4 py-10 text-center text-brand-muted">No events yet.</td></tr>}
          </tbody>
        </table>
      </div>
      <Modal open={open} onClose={() => setOpen(false)} title={editing ? "Edit Event" : "New Event"} size="lg">
        <form onSubmit={save} className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field label="Title *"><input required value={form.title} onChange={upd("title")} className="form-input" data-testid="event-title" /></Field>
          <Field label="Category"><select value={form.category} onChange={upd("category")} className="form-input"><option>Event</option><option>CME</option></select></Field>
          <Field label="Venue"><input value={form.venue} onChange={upd("venue")} className="form-input" /></Field>
          <Field label="Registration Link"><input value={form.registration_link} onChange={upd("registration_link")} className="form-input" /></Field>
          <Field label="Date *"><input required type="date" value={form.event_date} onChange={upd("event_date")} className="form-input" /></Field>
          <Field label="Time"><input value={form.event_time} onChange={upd("event_time")} className="form-input" placeholder="10:00" /></Field>
          <Field label="Banner URL"><input value={form.banner} onChange={upd("banner")} className="form-input" /></Field>
          <Field label="Status"><select value={form.status} onChange={upd("status")} className="form-input"><option value="upcoming">Upcoming</option><option value="past">Past</option><option value="cancelled">Cancelled</option></select></Field>
          <div className="md:col-span-2"><Field label="Description"><textarea rows={5} value={form.description} onChange={upd("description")} className="form-input" /></Field></div>
          <div className="md:col-span-2 flex justify-end gap-2"><button type="button" onClick={() => setOpen(false)} className="btn-ghost">Cancel</button><button className="btn-primary" data-testid="event-save">{editing ? "Update" : "Create"}</button></div>
        </form>
      </Modal>
    </div>
  );
}
